/*
 * Style switcher — uses Shopify's Section Rendering API to swap the main-product
 * section's contents when the shopper picks a different "style" (a separate
 * product linked via the style_group_selector metaobject). Falls back to a full
 * navigation if anything fails.
 *
 * Listens at the document level on the capture phase so it runs before any
 * other theme-level click handlers can hijack anchor navigation.
 */
(function () {
  if (window.__styleSwitcherInstalled) return;
  window.__styleSwitcherInstalled = true;

  function findHost(link) {
    var host = link.closest('style-switcher');
    if (host) return host;
    return document.querySelector('style-switcher');
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('[data-style-switch]');
      if (!link) return;

      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (link.getAttribute('aria-current') === 'true') return;

      var host = findHost(link);
      var sectionId = host && host.dataset && host.dataset.sectionId;
      var targetUrl = link.dataset.productUrl;
      var targetHandle = link.dataset.productHandle;
      var styleName = link.dataset.styleName;

      if (!sectionId || !targetUrl) {
        if (targetUrl) window.location.href = targetUrl;
        return;
      }

      var wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) {
        window.location.href = targetUrl;
        return;
      }

      wrapper.classList.add('is-style-switching');
      wrapper.setAttribute('aria-busy', 'true');
      if (host) host.classList.add('is-loading');

      var sep = targetUrl.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = targetUrl + sep + 'sections=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var newHtml = data[sectionId];
          if (newHtml == null) {
            var keys = Object.keys(data);
            for (var i = 0; i < keys.length; i++) {
              if (typeof data[keys[i]] === 'string' && data[keys[i]].length > 0) {
                newHtml = data[keys[i]];
                break;
              }
            }
          }
          if (newHtml == null) throw new Error('No usable section HTML in response');

          wrapper.innerHTML = newHtml;

          window.history.pushState(
            { styleSwitcher: true, url: targetUrl, handle: targetHandle },
            '',
            targetUrl
          );

          window.dispatchEvent(
            new CustomEvent('product:changed', {
              detail: { handle: targetHandle, url: targetUrl, style: styleName, sectionId: sectionId }
            })
          );
        })
        .catch(function () {
          window.location.href = targetUrl;
        })
        .finally(function () {
          wrapper.removeAttribute('aria-busy');
          wrapper.classList.remove('is-style-switching');
        });
    },
    true
  );

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.styleSwitcher) {
      window.location.reload();
    }
  });
})();
